module.exports = {
    "id": "elevator",
    "color": "green",
    "title": "elevator",
    "icon": "verticalarrows",
    "description": "Make a piece go up and down.",
    "category": "movement",
    "searchTags": ["up","down","move","auto","escalator",""],
    "exposedVariables": [
        {
            "variableName": "Elevator: Height",
            "spriteName": "$glitch_target",
            "tooltip":"Set the distance the piece will move",
            "input": {
                "type": "slider",
                "max": 360,
                "value": 60,
                "step": 1,
                "min": "0"
            },
            "value": "80"
        },
        {
            "variableName": "Elevator: Speed",
            "spriteName": "$glitch_target",
            "tooltip":"Set the speed the piece will move",
            "input": {
                "type": "slider",
                "max": 20,
                "value": 5,
                "min": "0",
                "step": ".1"
            },
            "value": "2"
        },
        {
            "variableName": "Elevator: Pause",
            "spriteName": "$glitch_target",
            "tooltip":"Set the amount of time the piece will pause at the top and bottom of its path",
            "input": {
                "type": "slider",
                "max": 5,
                "value": 1,
                "min": "0",
                "step": ".1"
            },
            "value": ".5"
        }
    ],
    "info": [
        {
            "text": "Make a piece move up and down forever",
            "image": "provision/glitches/elevator/elevator.gif"
        }
    ],
    "codeImage": "provision/glitches/elevator/elevator.png",
    "code": null,
    "zip": null,
    "sb3": null
};